import styled from 'styled-components';

import background from '../../../../assets/images/stack-bg.png';

export default styled.section`
  background: #e3ecf3;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BackgroundImage = styled.div`
  background: transparent url(${background}) 0% 0% no-repeat padding-box;
  top: -580px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  z-index: 1;
`;

export const MainLogo = styled.img`
  display: flex;
  margin: 4em auto;
`;

export const MainLogoContainer = styled.section`
  display: block;
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/CredentialsBoxWrapper/styled-components.js